import {
  Result,
  PanelMeasurement,
  Measurement,
  MeasurementDetail,
  CablePDMeasurement,
  TEVMeasurement,
  UHFMeasurement,
  UltraSonicMeasurement,
  VPISMeasurement,
} from "../interfaces/Result";
import { MeasurementType } from "../enums/Result";

export function doesAssetHaveMedia(result: Result, assetId: number) {
  return result?.dataValue?.MediaMetaData?.some((media) => media.AssetId === assetId);
}

type PanelMeasurementTypeKeys = keyof Pick<
  PanelMeasurement,
  "TEVMeasurements" | "UHFMeasurements" | "CablePDMeasurements" | "UltraSonicMeasurements" | "VPISMeasurements"
>;

export const PanelMeasurementKeysByMeasurementType: Record<MeasurementType, PanelMeasurementTypeKeys> = {
  [MeasurementType.TEV]: "TEVMeasurements",
  [MeasurementType.UHF]: "UHFMeasurements",
  [MeasurementType.CablePD]: "CablePDMeasurements",
  [MeasurementType.Ultra]: "UltraSonicMeasurements",
  [MeasurementType.VPIS]: "VPISMeasurements",
};

export function getMeasurementsByMeasurementType<T extends Measurement>(
  panelMeasurement: PanelMeasurement,
  measurementType: MeasurementType,
) {
  const measurementKey = PanelMeasurementKeysByMeasurementType[measurementType];
  return panelMeasurement[measurementKey] as Array<T>;
}

//Measurement Type Guards

export function isTEVMeasurement(measurement: Measurement): measurement is TEVMeasurement {
  return measurement.MeasurementType === MeasurementType.TEV;
}

export function isUHFMeasurement(measurement: Measurement): measurement is UHFMeasurement {
  return measurement.MeasurementType === MeasurementType.UHF;
}

export function isCablePDMeasurement(measurement: Measurement): measurement is CablePDMeasurement {
  return measurement.MeasurementType === MeasurementType.CablePD;
}

export function isUltraSonicMeasurement(measurement: Measurement): measurement is UltraSonicMeasurement {
  return measurement.MeasurementType === MeasurementType.Ultra;
}

export function isVPISMeasurement(measurement: Measurement): measurement is VPISMeasurement {
  return measurement.MeasurementType === MeasurementType.VPIS;
}

// Measuremen Detail Array type guards

export function isTEVMeasurementDetailArray(
  measurementDetail: MeasurementDetail<unknown>[],
): measurementDetail is MeasurementDetail<TEVMeasurement>[] {
  return measurementDetail.every((m) => isTEVMeasurement(m.measurement as TEVMeasurement));
}

export function isUHFMeasurementDetailArray(
  measurementDetail: MeasurementDetail<unknown>[],
): measurementDetail is MeasurementDetail<UHFMeasurement>[] {
  return measurementDetail.every((m) => isUHFMeasurement(m.measurement as UHFMeasurement));
}

export function isCablePDMeasurementDetailArray(
  measurementDetail: MeasurementDetail<unknown>[],
): measurementDetail is MeasurementDetail<CablePDMeasurement>[] {
  return measurementDetail.every((m) => isCablePDMeasurement(m.measurement as CablePDMeasurement));
}

export function isUltrasonicMeasurementDetailArray(
  measurementDetail: MeasurementDetail<unknown>[],
): measurementDetail is MeasurementDetail<UltraSonicMeasurement>[] {
  return measurementDetail.every((m) => isUltraSonicMeasurement(m.measurement as UltraSonicMeasurement));
}

export function isVPISMeasurementDetailArray(
  measurementDetail: MeasurementDetail<unknown>[],
): measurementDetail is MeasurementDetail<VPISMeasurement>[] {
  return measurementDetail.every((m) => isVPISMeasurement(m.measurement as VPISMeasurement));
}
